var React = require('react');

function ArrowRoundedUp13x8 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.4,7.7l-4.9-5l-4.9,5c-0.4,0.4-0.9,0.4-1.3,0l0,0c-0.4-0.4-0.4-0.9,0-1.3L6.5,0l6.2,6.4c0.4,0.4,0.3,0.9,0,1.3l0,0\r\n\tC12.4,8.1,11.8,8.1,11.4,7.7z"}));
}

ArrowRoundedUp13x8.defaultProps = {"width":"13","height":"8"};

module.exports = ArrowRoundedUp13x8;

ArrowRoundedUp13x8.default = ArrowRoundedUp13x8;
